import { HeaderInfoGroup } from "@/modules/InfoGroup/models/HeaderInfoGroup";
import { VoidedObject } from "@/shared/models/voided-object.model";

export class UserTemplate extends VoidedObject {
  _key?: string;
  name!: string;
  description!: string;
  prompt?: string;
  state!: string;
  infoGroups!: Array<string> | HeaderInfoGroup[];
  visualElement!: string;
  version?: number;
}
